

const ModuleProgress = {
    completedModules: [],
    elements: {
        $articles: document.querySelectorAll('.js-module-article'),
        $checkboxes: document.querySelectorAll('.js-module-checkbox'),
        $reset: document.querySelector('.js-module-reset'),
        $accordionTrigger: document.querySelectorAll('.js-module-accordion-trigger')
    },
    init() {
        const self = this;

        // Get completed modules from localStorage
        self.completedModules = JSON.parse(localStorage.getItem('completedModules')) || [];

        // Check completed modules, if there are any, check respective checkboxes (data-module-id)
        self.completedModules.forEach((module) => {
            self.elements.$checkboxes.forEach(($checkbox) => {
                if ($checkbox.dataset.moduleId === module) {
                    $checkbox.checked = true;
                }
            });
        });

        self.elements.$checkboxes.forEach(($checkbox) => {
            // On change, toggle module completion
            $checkbox.addEventListener('change', self.toggleModule.bind(self));
        });

        self.elements.$articles.forEach(($article) => {
            // When page is scrolled, check if the article scroll is at the bottom
            window.addEventListener('scroll', function() {
                self.checkArticleScroll($article);
            });

        });

        // Reset button
        self.elements.$reset.addEventListener('click', function() {
            self.completedModules = [];
            localStorage.removeItem('completedModules');
            self.elements.$checkboxes.forEach(($checkbox) => {
                $checkbox.checked = false;
            });
        });

        // Accordion trigger, also supports <details> element
        self.elements.$accordionTrigger.forEach(($trigger) => {
            $trigger.addEventListener('click', function() {
                const targetId = this.dataset.moduleId;
                const $targets = document.querySelectorAll(`.js-module-accordion-target[data-module-id="${targetId}"]`);

                if ($targets) {
                    $targets.forEach(($target) => {
                        $target.classList.toggle('is-active');
                        $trigger.classList.toggle('is-active');

                        // If the trigger is a <details> element, toggle the open attribute
                        $target.open = !$target.open;
                    });
                }
            });
        });
    },

    toggleModule(event) {
        const self = this;
        const moduleId = event.target.dataset.moduleId;

        // Update the completedModules array, if the checkbox is checked, add the module ID, otherwise remove it
        if (event.target.checked) {
            self.completedModules.push(moduleId);
        } else {
            self.completedModules = self.completedModules.filter((module) => module !== moduleId);
        }

        // Update the localStorage
        localStorage.setItem('completedModules', JSON.stringify(self.completedModules));
    },

    checkArticleScroll($article) {
        const self = this;
        const articleHeight = $article.scrollHeight;
        const articleOffset = $article.offsetTop;
        const articleScroll = window.scrollY;
        const articlePosition = articleOffset + articleHeight;

        // If the scroll position is at the bottom of the article, mark the module as completed
        if (articlePosition <= articleScroll + window.innerHeight) {
            const moduleId = $article.dataset.moduleId;
            self.elements.$checkboxes.forEach(($checkbox) => {
                if ($checkbox.dataset.moduleId === moduleId) {
                    $checkbox.checked = true;
                    self.toggleModule({ target: $checkbox });
                }
            });
        }
    }
};

export { ModuleProgress };
